import React, { Component } from 'react';
import AddJobForm from '../../components/AddJobForm/AddJobForm';
import { Container, Col, Row } from '../../components/Grid';

import { connect } from 'react-redux';
import { addJobThunk, resetAddJob } from './actions';

import { AttentionSeeker } from 'react-awesome-reveal'; // Updated import
import { withTheme } from '../higherOrderComponents/withTheme';
import walkingIcon from 'icons/walking.svg'; // Import the SVG

class AddJob extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.addJob.status !== this.props.addJob.status && this.props.addJob.status) {
      // Optionally reset the form or state here
      this.props.resetAddJob();
    }
  }

  render() {
    const { addJob, addJobThunk, themeMode } = this.props;
    
    const styles = {
      card: {
        backgroundColor: themeMode === 'dark' ? '#282828' : '#fff',
        color: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'inherit',
        borderRadius: '15px',
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
      },
      input: {
        backgroundColor: themeMode === 'dark' ? '#383838' : '#fff',
        color: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'inherit',
        borderColor: themeMode === 'dark' ? '#555' : '#ced4da'
      },
      label: {
        color: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'inherit',
      }
    };

    return (
      <Container className="pt-5">
        <Row className="justify-content-center text-center">
          <Col size="12 lg-10">
            <AttentionSeeker effect="rubberBand">
              <img
                width="80%"
                src={walkingIcon}
                alt="hunt the deer"
              />
            </AttentionSeeker>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <h3 className="montserrat font-weight-bold mt-3">
              Track a New Job
            </h3>
            <h6>
              Found a job from somewhere else? Import it here and you'll be able
              to track your progress!
            </h6>
          </Col>
        </Row>
        <AddJobForm onSubmitForm={addJobThunk} errorMessage={addJob.error} isLoading={addJob.loading} styles={styles} />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  addJob: state.addJob,
});

const mapDispatchToProps = {
  addJobThunk,
  resetAddJob,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(AddJob));
